import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=fc366b88&scoped=true"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=fc366b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc366b88",
  null
  
)

export default component.exports